module.exports = __webpack_public_path__ + "img/zhinengzhizao_zhonghuan_1.5a2da01f.png";